/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Slider_Cta_FreeInputs */

const en_app_slider_cta_free = /** @type {(inputs: App_Slider_Cta_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try Now for Free`)
};

const es_app_slider_cta_free = /** @type {(inputs: App_Slider_Cta_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prueba gratis ahora`)
};

/**
* | output |
* | --- |
* | "Try Now for Free" |
*
* @param {App_Slider_Cta_FreeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const app_slider_cta_free = /** @type {((inputs?: App_Slider_Cta_FreeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Slider_Cta_FreeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_app_slider_cta_free(inputs)
	return en_app_slider_cta_free(inputs)
});